import { combineReducers } from 'redux';
import authReducer from './authReducer';
import dashboardReducer from './dashboardReducer';
import exploreReducer from './exploreReducer';
import usersReducer from './usersReducer';
import bvnUsersReducer from './bvnUsersReducer';
import storage from 'redux-persist/es/storage';
import { USER_LOGOUT } from '../actions/constants';

// const rootReducer = {
//   auth: authReducer,
//   dashboard: dashboardReducer,
//   explore: exploreReducer,
//   users: usersReducer,
//   bvnUsers: bvnUsersReducer,
// };

const appReducer = combineReducers({
	auth: authReducer,
	dashboard: dashboardReducer,
	explore: exploreReducer,
	users: usersReducer,
	bvnUsers: bvnUsersReducer,
});

const rootReducer = (state, action) => {
	if (action.type === USER_LOGOUT) {
		// for all keys defined in your persistConfig(s)
		storage.removeItem('persist:rich-oak-app');
		return appReducer(undefined, action);
	}
	return appReducer(state, action);
};

export default rootReducer;
